var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { CrazyCallConfigService } from '../lead-generation/shared/services/crazycall-config.service';
import { GET_REPORTS_META_DATA, GET_OVERALL_REPORTS_META_DATA, GET_PROJECTS, GetMetaDataFailureAction, GetMetaDataSuccessAction, GetOverallMetaDataFailureAction, GetOverallMetaDataSuccessAction, GetProjectsFailureAction, GetProjectsSuccessAction } from './reports.actions';
import { ReportsService } from './reports.service';
var ReportsEffects = /** @class */ (function () {
    function ReportsEffects(actions$, crazyCallConfigService, reportService) {
        var _this = this;
        this.actions$ = actions$;
        this.crazyCallConfigService = crazyCallConfigService;
        this.reportService = reportService;
        this.getProjects = this.actions$.pipe(ofType(GET_PROJECTS), switchMap(function () {
            return _this.crazyCallConfigService
                .getProjects()
                .pipe(map(function (response) { return new GetProjectsSuccessAction(response); }), catchError(function (error) { return of(new GetProjectsFailureAction(error)); }));
        }));
        this.getMetaData = this.actions$.pipe(ofType(GET_REPORTS_META_DATA), switchMap(function () {
            return _this.reportService
                .getReportMetaData()
                .pipe(map(function (response) { return new GetMetaDataSuccessAction(response); }), catchError(function (error) { return of(new GetMetaDataFailureAction(error)); }));
        }));
        this.getOverallMetaData = this.actions$.pipe(ofType(GET_OVERALL_REPORTS_META_DATA), switchMap(function () {
            return _this.reportService
                .getReportOverallMetaData()
                .pipe(map(function (response) { return new GetOverallMetaDataSuccessAction(response); }), catchError(function (error) { return of(new GetOverallMetaDataFailureAction(error)); }));
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ReportsEffects.prototype, "getProjects", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ReportsEffects.prototype, "getMetaData", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ReportsEffects.prototype, "getOverallMetaData", void 0);
    return ReportsEffects;
}());
export { ReportsEffects };
